import Card from "@mui/material/Card";
import { Grid, Typography, TextField } from '@mui/material';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import authorsTableData from "layouts/tables/data/authorsTableData";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { toast } from 'react-toastify';
import { CircularProgress, Backdrop } from "@mui/material";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { handleErrors, formatAmountWithRupeeSymbol, checkPrivilege } from "common.js";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { WITHDRAWAL } from 'constants.js';
import { PRIVILEGE } from "constants.js";

function WithdrawalView(props) {
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [withdrawalData, setWithdrawalData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const data = (id) => {
    setIsLoading(true);
    axios({
      url: BASE + "api/withdrawal/view/" + id,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setWithdrawalData(response.data)
          setIsLoading(false);
        }
        else {
          toast.error(t(message));
          (function () {
            const redirectTimeout = setTimeout(() => {
              clearTimeout(redirectTimeout);
              navigate('/withdrawal/list/', { replace: true });
            }, 3000);
          })()
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data(id);
  }, []);

  const getStatusText = (status) => {
    return status === WITHDRAWAL.COMPLETED ? t('Completed') : t('Pending');
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    data.id = id;
    axios({
      url: BASE + "api/withdrawal/updateStatus",
      method: "POST",
      data: data,
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message));
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/withdrawal/list/', { replace: true })
          }, 3000);
        }
        else {
          if (message)
            toast.error(t(message));
          if (response.data.errors.length > 0)
            response.data.errors.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: error.errors[0]
              });
            })
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t('Withdrawal details')} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={6} pb={3} >
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {(withdrawalData.data) ?
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2} mt={5} ml={2} mb={5}>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('id')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{withdrawalData.data.id}</Typography>
                    </Grid>
                    {/* Repeat the pattern for other fields */}
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Total price')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{formatAmountWithRupeeSymbol(withdrawalData.data.totalPrice)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Admin charge')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{formatAmountWithRupeeSymbol(withdrawalData.data.adminCommission)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Vendor due')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{formatAmountWithRupeeSymbol(withdrawalData.data.vendorAmount)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Shipping cost')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{formatAmountWithRupeeSymbol(withdrawalData.data.shippingCost)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('Return cost')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{formatAmountWithRupeeSymbol(withdrawalData.data.returnCost)}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <label className="font-style">{t('status')}</label>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8}>
                      <Typography variant="body2" className="setSpan">{getStatusText(withdrawalData.data.status)}</Typography>
                    </Grid>
                    {(withdrawalData.data.status == 1) ?
                      <>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="font-style">{t('transactionReferenceNumber')}</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <Typography variant="body2" className="setSpan">{withdrawalData.data.transactionId || '-'}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="font-style">{t('Remarks')}</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <TextField
                            multiline
                            variant="outlined"
                            value={withdrawalData.data.remarks}
                          />
                        </Grid>
                      </>
                      :
                      <>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="font-style">{t('Transaction Id')}</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput type="text" name="transactionId"  {...register("transactionId", { required: true })} />
                          {errors.transactionId && errors.transactionId.type === "required" && (
                            <p className="errorMsg">{t('Transaction Id is mandatory')}</p>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="font-style">{t('Remarks')}</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput type="text" name="remarks"  {...register("remarks")} />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("withdrawal", "write"))) ?
                            <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>
                              {t('Mark As Paid')}
                            </MDButton>
                            : null}
                        </Grid>
                      </>
                    }
                  </Grid>
                </MDBox>
                :
                <Typography variant="body2" className="setSpan">{t('No data available')}</Typography>
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default WithdrawalView;
